import { UseQueryOptions, useQuery } from '@tanstack/vue-query';
import { Ref } from 'vue';
import { FeedReconciliation } from '@/types';
import ApiRequest from '@/plugins/store/actions/api/ApiRequest';

export const queryKeys = {
    getFeedReconciliationsRoot: ['feed-reconciliations'],
    getFeedReconciliations: (siteIds: Ref<number[]>) => [...queryKeys.getFeedReconciliationsRoot, { siteIds }],
};

export function useFeedReconciliations(siteIds: Ref<number[]>, options: UseQueryOptions<FeedReconciliation[]> = {}) {
    return useQuery<FeedReconciliation[]>({
        queryKey: queryKeys.getFeedReconciliations(siteIds),
        queryFn: () => new ApiRequest().send('get', `feed/reconciliations?location_ids=${siteIds.value.join(',')}`),
        ...options,
    });
}
